/**
 * The only paths a report-only account (`accessLevel: "none"`, GRA-96) may
 * reach: the Reports page plus their own appearance, notification and
 * profile settings.
 */
const REPORT_ONLY_ALLOWED_PREFIXES = [
  "/reports",
  "/bruttovinst",
  "/settings/appearance",
  "/settings/notifications",
  "/profile",
  "/more",
];

export function isPathAllowedForReportOnly(pathname: string): boolean {
  return REPORT_ONLY_ALLOWED_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`),
  );
}
